import Auth from 'live/services/authorization'

export function canManageRig () {
    return Auth.Permission.isAdmin || Auth.Permission.MANAGE_RIGS
}

export function canViewRig () {
    return canManageRig() || Auth.Permission.VIEW_RIGS
}

export function canViewWells() {
    return Auth.Permission.isAdmin || Auth.Permission.VIEW_WELLS
}

export function canViewNavigation() {
    return Auth.Permission.isAdmin || Auth.Permission.METADATA_NAVIGATION
}

export const canSeeDashboards = !!(
    Auth.Permission.DASHBOARDS ||
    Auth.Permission.MANAGE_DASHBOARDS ||
    Auth.Permission.isAdmin
)
